import { render, staticRenderFns } from "./SingleView.vue?vue&type=template&id=c504709e&scoped=true&"
import script from "./SingleView.vue?vue&type=script&lang=js&"
export * from "./SingleView.vue?vue&type=script&lang=js&"
import style0 from "./SingleView.vue?vue&type=style&index=0&id=c504709e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c504709e",
  null
  
)

export default component.exports